import { API_BASE_URL } from "../config";
import { getAccessToken } from "./auth-helper";

export type SignatureAssetUploadResult = {
  assetId: string;
  fileName: string;
  contentType: string;
  format: string;
};

export type SignatureAssetBase64Result = {
  assetId: string;
  fileName: string;
  contentType: string;
  base64: string;
};

/**
 * Explizite Zugangsdaten für Kontexte ohne `window`: die Launch-Runtime von Outlook Classic
 * (autorunweb.js) hat weder sessionStorage noch localStorage, `getAccessToken()` liefert dort null.
 */
export type SignatureAssetAuth = { apiBase?: string; accessToken?: string };

export async function uploadSignatureAsset(file: File): Promise<SignatureAssetUploadResult> {
  const token = getAccessToken();
  if (!token) throw new Error("not_authenticated");
  const body = new FormData();
  body.append("file", file, file.name);
  const res = await fetch(`${API_BASE_URL}/api/signature-assets`, {
    method: "POST",
    headers: { Authorization: `Bearer ${token}` },
    body,
    credentials: "omit",
  });
  if (!res.ok) {
    const text = await res.text().catch(() => "");
    throw new Error(text || `upload_failed_${res.status}`);
  }
  return (await res.json()) as SignatureAssetUploadResult;
}

export async function fetchSignatureAssetBase64(
  assetId: string,
  auth?: SignatureAssetAuth
): Promise<SignatureAssetBase64Result> {
  const token = auth?.accessToken || getAccessToken();
  if (!token) throw new Error("not_authenticated");
  const base = (auth?.apiBase || API_BASE_URL).replace(/\/+$/, "");
  const res = await fetch(`${base}/api/signature-assets/${encodeURIComponent(assetId)}/base64`, {
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
    credentials: "omit",
  });
  if (!res.ok) throw new Error(`asset_fetch_failed_${res.status}`);
  return (await res.json()) as SignatureAssetBase64Result;
}
